module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showOver) ? _c('gameOver', {
    attrs: {
      "score": _vm.gameScore,
      "gameFlag": _vm.gameType
    },
    on: {
      "restart": _vm.restartTrain,
      "close": _vm.closeGame
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "dialogClass": "trainPlan-dialog",
      "open": _vm.showDialog
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "flex-demoLeft"
  }, [_c('mu-paper', {
    staticStyle: {
      "width": "240px",
      "height": "240px"
    },
    attrs: {
      "zDepth": 1
    }
  }, [_c('img', {
    staticStyle: {
      "width": "240px",
      "height": "240px"
    },
    attrs: {
      "src": _vm.address + _vm.$parent.game.image
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "padding": "0",
      "margin-top": "0",
      "margin-bottom": "0",
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.$parent.game.name))]), _vm._v(" "), _vm._l((_vm.$parent.game.label_desc), function(item) {
    return _c('span', {
      staticClass: "title-style",
      staticStyle: {
        "padding": "0px",
        "font-size": "14px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.name) + "  ")])
  })], 2)], 1), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-demoRight"
  }, [_c('div', {
    staticClass: "body-right-head"
  }, [(_vm.showInput) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.search.keyword),
      expression: "$parent.search.keyword"
    }],
    staticClass: "inputName",
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名搜索..."
    },
    domProps: {
      "value": (_vm.$parent.search.keyword)
    },
    on: {
      "keyup": _vm.showAllIfNull,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$parent.search, "keyword", $event.target.value)
      }
    }
  }), _c('i', {
    staticClass: "searchicon pointer",
    on: {
      "click": _vm.$parent.searchList
    }
  }, [_vm._v("搜")])]) : _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#333"
    }
  }, [_vm._v("训练设置")]), _vm._v(" "), (_vm.showConf) ? _c('div', {
    staticClass: "select-level-wrap"
  }, [_c('selectLevel', {
    attrs: {
      "defaultTime": _vm.defaultTime,
      "showHardBar": _vm.showHardBar
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showConf) ? _c('div', {
    staticClass: "select-level-wrap"
  }, [_vm._v("\n              暂无设置\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.showInput) ? _c('div', [_c('div', {
    staticClass: "body-right-foot"
  }, [(Object.keys(_vm.$parent.caseLists).length > 0) ? _c('ul', _vm._l((_vm.$parent.caseLists), function(caseList, index) {
    return _c('li', {
      class: {
        'on': _vm.$parent.flag == caseList.id
      },
      on: {
        "click": function($event) {
          _vm.$parent.choseMe(caseList.id, caseList.name)
        }
      }
    }, [(caseList.name != '临时测评虚拟患者') ? [_c('span', [_vm._v(_vm._s((caseList.name + '').substr(-2, 2)))]), _vm._v(" "), _c('i', [_vm._v(_vm._s(caseList.name))]), _vm._v("，" + _vm._s(caseList.gender == '1' ? '女' : '男') + "，" + _vm._s(caseList.age) + "岁\n                ")] : _vm._e()], 2)
  })) : _c('ul', [_c('li', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("无搜索结果")])])])]) : _vm._e()])], 1), _vm._v(" "), _c('mu-flexbox', [_c('mu-flexbox-item', [_c('div', {
    staticClass: "footer-left"
  })]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "footer-right"
  }, [_c('div', {
    staticClass: "footer-down"
  }, [(_vm.saveGame) ? _c('trainCronSave', {
    attrs: {
      "rest": _vm.rest,
      "gameData": _vm.$parent.game,
      "gameFlag": _vm.gameFlag,
      "caseId": _vm.$route.params.id,
      "caseName": _vm.$parent.caseName,
      "todayGames": _vm.todayGames
    },
    on: {
      "update:rest": function($event) {
        _vm.rest = $event
      },
      "restart": _vm.restartLanTrain,
      "updateScore": _vm.getGameScore,
      "close": function($event) {
        _vm.saveGame = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.showMes,
      "title": "提示"
    }
  }, [_vm._v("\n                请先选择一个患者！\n                "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.showMes = false
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.showInput) ? _c('a', {
    staticClass: "pointer a-font",
    on: {
      "click": function($event) {
        _vm.openGame(0)
      }
    }
  }, [_vm._v("临时练习")]) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "margin-top": "5px",
      "color": "#999"
    },
    attrs: {
      "slot": "actions",
      "label": "取消"
    },
    on: {
      "click": _vm.cancelGame
    },
    slot: "actions"
  }), _vm._v(" "), (_vm.showInput) ? _c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "id": "justTrain",
      "disabled": ""
    },
    on: {
      "click": function($event) {
        _vm.openGame(1)
      }
    }
  }, [_vm._v("立刻训练")]) : _c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "5px",
      "background-color": "rgb(10, 129, 229)",
      "border-radius": "0px"
    },
    attrs: {
      "id": "justTrain",
      "disabled": !_vm.startTrain
    },
    on: {
      "click": function($event) {
        _vm.beginTrain(_vm.game)
      }
    }
  }, [_vm._v("开始训练")])], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25b1c05c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/train/trainContentmodal.vue
// module id = 965
// module chunks = 2